import React from 'react';
import { useTranslation } from 'react-i18next';

import { drugsModel } from '../../../constants';
import { LabeledSelect } from '../Input/LabeledSelect';

const DrugRequestStatusSelect = ({ allowClear = true,
  disabled, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      disabled={ disabled }
      allowClear={ allowClear }
      options={ [
        { value: drugsModel.DRUG_REQUEST_STATUS.APPROVED, text: t('fields.status.approved') },
        { value: drugsModel.DRUG_REQUEST_STATUS.REJECTED, text: t('fields.status.rejected') },
        { value: drugsModel.DRUG_REQUEST_STATUS.WAITING_FOR_APPROVAL, text: t('fields.status.waitingApp') }
      ] }
    />
  );
};
export default DrugRequestStatusSelect;
